import type { Middleware, Placement as FloatingPlacement } from '@floating-ui/core';
import { flip, autoPlacement } from '@floating-ui/react';

import type { Placement } from './types.ts';

export function getFloatingPlacement(placement: Placement): [FloatingPlacement | undefined, Middleware | undefined] {
  switch (placement) {
    case 'auto':
      return [undefined, autoPlacement()];
    case 'auto-end':
      return [
        undefined,
        autoPlacement({
          allowedPlacements: ['top-end', 'bottom-end', 'left-end', 'right-end'],
        }),
      ];
    case 'auto-start':
      return [
        undefined,
        autoPlacement({
          allowedPlacements: ['top-start', 'bottom-start', 'left-start', 'right-start'],
        }),
      ];
    case 'top':
    case 'bottom':
    case 'right':
    case 'left':
    case 'top-start':
    case 'top-end':
    case 'bottom-start':
    case 'bottom-end':
    case 'right-start':
    case 'right-end':
    case 'left-start':
    case 'left-end':
      return [
        placement,
        flip({
          mainAxis: true,
          crossAxis: true,
          fallbackAxisSideDirection: 'start',
        }),
      ];

    default:
      // @ts-expect-error - when all cases covered
      return null;
  }
}
